import { gql } from '@apollo/client';

// Without a version, the round's latest stored optimization run.
export const SALE_BID_REPORT_QUERY = gql`
  query SaleBidReport($saleId: ID!, $round: Int!, $version: Int) {
    saleBidReport(sale_id: $saleId, round: $round, version: $version) {
      __typename
      file_name
      content_type
      content_base64
    }
  }
`;
